/*
 * Purpose : Tool Search page for linked tool status
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, {useEffect, useState, useCallback} from 'react'
import {NavLink} from "react-router-dom"
import { Col, Card, Alert, CardTitle, CardText, FormGroup, Row } from "reactstrap";
import {FaSearch} from "react-icons/fa"
import { MdVisibility } from "react-icons/md";
import {AiOutlineClose} from "react-icons/ai"

import RSInput from "../../UI/CustInput/RSInput/RSInput";
import ToolSalesButton from '../../UI/Buttons/ToolSalesButton/ToolSalesButton';
import { ToolSalesFormService } from '../../../services/ToolSalesFormService';
import {toolStatusDetailsHeaders} from "../../../config/constants";
import ViewItem from '../../UI/CustInput/ViewItem/ViewItem'
import {colors} from "../../../styleConstants"
import './ToolStatusSearch.css';

const formService = new ToolSalesFormService();

const ToolStatusSearch = (props) => {
    const[toolId, setToolId] = useState()
    const[toolList, setToolList] = useState([])
    const[processing, setProcessing] = useState(false)
    const[dealList, setDealList] = useState([])
    const[feedback, setFeedback] = useState(null)

    //for tooltip
    //const [tooltipOpen, setTooltipOpen] = useState(false);
    //const toggle = () => setTooltipOpen(!tooltipOpen);

    const getDropDown = useCallback( async () =>{
        // getting dropdown data
        let dropdownList;
        try {
          dropdownList = await formService.getDropdownValuesForToolSearch()
        } catch (error) {
          console.log("There is a technical error. Please try again..!")
          setFeedback("There is a technical error. Please try again..!")
          return false
        }        
        //setting tools dropdown
        setToolList(dropdownList)
    },[])

    // get tools depends on toolid
    const getToolStatusDetails = async () => {
        if(!toolId || toolId ===""){
            setFeedback("Please select Tool ID")
            return false
        }
        let toolStatusDetails;
        try {
            setProcessing(true)
            toolStatusDetails = await formService.getToolStatusDetails(toolId)
            console.log("toolStatusDetails==>",toolStatusDetails.length)
            toolStatusDetails.length === 0 ? setFeedback(toolId+" is not linked with any Transaction.") : setFeedback(null)
            setDealList(toolStatusDetails)
            setProcessing(false)
        } catch (error) {
            console.log("There is a technical error. Please try again..!")
            setFeedback("There is a technical error. Please try again..!")
            return false
        }
    }

    useEffect(() => {        
        const initialData = async() => await getDropDown()
        initialData()
        return () => {            
        }
    }, [getDropDown])

    return (
        <div>
            <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }} >
            <Row form style={{ justifyContent: "flex-start" }}>
              <Col md={5}>
                <RSInput type="select" name="toolid" id="toolid"
                    required={true}                 
                    labelText="Tool ID" 
                    onChange={(e)=>setToolId(e.target.value)} >   
                    <option value="">--- Select a Tool ---</option>                                   
                    {toolList.map((el) => (
                      <option key={el.toolid} value={el.toolid}>{el.toolid}</option>
                    ))}                    
                </RSInput>
              </Col>
              <Col md={5}>                
              <Row form style={{ justifyContent: "flex-start", marginTop:"30px" }}>          
                <Col md="auto">
                    <ToolSalesButton style={{backgroundColor: colors.infoColor}} onClick={() => getToolStatusDetails() } ><FaSearch style={{ fontSize: "20px"}}/>&nbsp;&nbsp;
                    { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                    { !processing && <span>Search</span> } 
                    </ToolSalesButton>
                </Col>
                <Col md="auto">
                    <ToolSalesButton style={{backgroundColor: "#c1c1c1"}} onClick={() => props.setDis(false) } ><AiOutlineClose style={{ fontSize: "20px"}}/>&nbsp;&nbsp;Close</ToolSalesButton>
                </Col>            
            </Row>
              </Col>
            </Row>
            <Alert color="danger" isOpen={feedback != null ? true : false}>
                {feedback}
            </Alert>
            <Row form style={{ justifyContent: "flex-start"}}>
            {
                dealList.map( (element, idx) =>{
                    return (
                        <Col key={idx} lg="auto" style={{marginBottom:"10px",width:"-webkit-fill-available"}}>                            
                            <Card body className={"cardCustBody"}>
                                <Row>
                                    <Col>
                                        <CardTitle tag="h6">{toolStatusDetailsHeaders.deal_ref} : {element.deal_ref}&nbsp;&nbsp;&nbsp;&nbsp;
                                        <NavLink  to={`/toolsales/viewform/${element.transactionid}`} style={{textDecoration: 'none', color:colors.infoColor}}>
                                            <MdVisibility  style={{ fontSize: "20px"}}/>&nbsp;<span className="actionTag">View Transaction</span>
                                        </NavLink>
                                        {/* <Tooltip
                                            placement="auto"
                                            isOpen={tooltipOpen}                                            
                                            target="actionNav"
                                            toggle={toggle}
                                        >
                                            View Transaction
                                        </Tooltip> */}
                                        </CardTitle>
                                    </Col>
                                </Row>
                                <CardText style={{fontWeight:"500",color:"#17a2b8"}}>{toolStatusDetailsHeaders.toolid} : {element.toolid}</CardText>
                                <Row style={{ justifyContent: "space-evenly", marginTop:"2px", marginLeft:"2%" }}>
                                    <Col md="12">
                                        <FormGroup>
                                            <Row form style={{ justifyContent: "felx-start" }}>
                                                {Object.keys(toolStatusDetailsHeaders).map( key => 
                                                    (key !== "toolid" && key!=="deal_ref" ) 
                                                    ?
                                                        (key === "remarks")
                                                        ?
                                                        <ViewItem tag={toolStatusDetailsHeaders[key]} value={element[key]} width="6"/>
                                                        :
                                                        <ViewItem tag={toolStatusDetailsHeaders[key]} value={element[key]} width="3"/>
                                                    :
                                                    ""
                                                    // displayItem(toolStatusDetailsHeaders[key], element[key])
                                                )}                                                                                                        
                                            </Row>                                        
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {/* <Row form style={{ justifyContent: "flex-end" }}>          
                                    <Col md="auto">
                                        <NavLink to="/toolsalesform">
                                            <ToolSalesButton style={{backgroundColor: "#17a2b8"}} ><MdVisibility  style={{ fontSize: "20px"}}/>&nbsp;&nbsp;View Transaction</ToolSalesButton>
                                        </NavLink>
                                    </Col>
                                    <Col md="auto">
                                        <NavLink to="/toolsalesform">
                                            <ToolSalesButton style={{backgroundColor: "#ffc107"}} onClick={() => props.setDis(false) } ><MdEdit  style={{ fontSize: "20px"}}/>&nbsp;&nbsp;Edit Transaction</ToolSalesButton>
                                        </NavLink>
                                    </Col>            
                                </Row> */}
                            </Card>
                        </Col>)
                })
            }
            </Row>            
          </div>
        </div>
    )
}

export default ToolStatusSearch
